import React, {useEffect} from "react";
import {Button, Col, Form, Modal, Row, Spinner} from "react-bootstrap";
import {useState} from "react";
import axios from "axios";
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";

const UpdateRadonTestReport = () => {

    let navigate = useNavigate();

    const {id} = useParams();

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const [useId, setId] = useState()

    const [client_name, set_client_name] = useState('')
    const [test_address, set_test_address] = useState('')
    const [city, set_city] = useState('')
    const [state, set_state] = useState('')
    const [zip, set_zip] = useState('')
    const [manufacturer_and_model1, set_manufacturer_and_model1] = useState('')
    const [serial_number1, set_serial_number1] = useState('')
    const [calibration_date1, set_calibration_date1] = useState('')
    const [test_location1, set_test_location1] = useState('')
    const [start_date1, set_start_date1] = useState('')
    const [start_time1, set_start_time1] = useState('')
    const [end_date1, set_end_date1] = useState('')
    const [end_time1, set_end_time1] = useState('')
    const [average_radon_level1, set_average_radon_level1] = useState('')
    const [manufacturer_and_model2, set_manufacturer_and_model2] = useState('')
    const [serial_number2, set_serial_number2] = useState('')
    const [calibration_date2, set_calibration_date2] = useState('')
    const [test_location2, set_test_location2] = useState('')
    const [start_date2, set_start_date2] = useState('')
    const [start_time2, set_start_time2] = useState('')
    const [end_date2, set_end_date2] = useState('')
    const [end_time2, set_end_time2] = useState('')
    const [average_radon_level2, set_average_radon_level2] = useState('')
    const [pcil2, set_pcil2] = useState('')
    const [licensed_radon_professional, set_licensed_radon_professional] = useState('')
    const [MDH_license_number, set_MDH_license_number] = useState('')
    const [email, set_email] = useState('')
    const [phone, set_phone] = useState('')
    const [fax, set_fax] = useState('')
    const [noninterference_agreement, set_noninterference_agreement] = useState('')
    const [test_conditions_observed, set_test_conditions_observed] = useState('')
    const [property_was_vacant, set_property_was_vacant] = useState('')
    const [testing_device_placed, set_testing_device_placed] = useState('')
    const [testing_device_reason, set_testing_device_reason] = useState('')
    const [observed_closed_building, set_observed_closed_building] = useState('')
    const [building_temperature, set_building_temperature] = useState('')
    const [radon_test_device_moved, set_radon_test_device_moved] = useState('')
    const [test_data_interference, set_test_data_interference] = useState('')
    const [tamper_resistant_device, set_tamper_resistant_device] = useState('')
    const [radon_mitigation_observed, set_radon_mitigation_observed] = useState('')
    const [test_system_operational, set_test_system_operational] = useState('')
    const [temporary_mitigation_observed, set_temporary_mitigation_observed] = useState('')
    const [temporary_mitigation_observed_description, set_temporary_mitigation_observed_description] = useState('')
    const [heat_recovery_ventilator, set_heat_recovery_ventilator] = useState('')
    const [operation_during_test, set_operation_during_test] = useState('')
    const [functional_properly_maintained, set_functional_properly_maintained] = useState('')
    const [intake_free_of_obstacles, set_intake_free_of_obstacles] = useState('')
    const [severe_storms, set_severe_storms] = useState('')
    const [passive_crawlspace, set_passive_crawlspace] = useState('')
    const [passive_crawlspace_open_closed, set_passive_crawlspace_open_closed] = useState('')
    const [active_or_passive_air, set_active_or_passive_air] = useState('')
    const [operating_as_intended, set_operating_as_intended] = useState('')
    const [forced_air, set_forced_air] = useState('')
    const [fan_setting, set_fan_setting] = useState('')
    const [sub_slab_ducts, set_sub_slab_ducts] = useState('')
    const [air_handler_fan, set_air_handler_fan] = useState('')
    const [unavoidable_construction, set_unavoidable_construction] = useState('')
    const [other_temporary_factors, set_other_temporary_factors] = useState('')

    const loadRadonTest = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/radon_test_report/${id}/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/radon_test_report/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        });
        setId(data.id)
        set_client_name(data.client_name)
        set_test_address(data.test_address)
        set_city(data.city)
        set_state(data.state)
        set_zip(data.zip)
        set_manufacturer_and_model1(data.manufacturer_and_model1)
        set_serial_number1(data.serial_number1)
        set_calibration_date1(data.calibration_date1)
        set_test_location1(data.test_location1)
        set_start_date1(data.start_date1)
        set_start_time1(data.start_time1)
        set_end_date1(data.end_date1)
        set_end_time1(data.end_time1)
        set_average_radon_level1(data.average_radon_level1)
        set_manufacturer_and_model2(data.manufacturer_and_model2)
        set_serial_number2(data.serial_number2)
        set_calibration_date2(data.calibration_date2)
        set_test_location2(data.test_location2)
        set_start_date2(data.start_date2)
        set_start_time2(data.start_time2)
        set_end_date2(data.end_date2)
        set_end_time2(data.end_time2)
        set_average_radon_level2(data.average_radon_level2)
        set_pcil2(data.pcil2)
        set_licensed_radon_professional(data.licensed_radon_professional)
        set_MDH_license_number(data.MDH_license_number)
        set_email(data.email)
        set_phone(data.phone)
        set_fax(data.fax)
        set_noninterference_agreement(data.noninterference_agreement)
        set_test_conditions_observed(data.test_conditions_observed)
        set_property_was_vacant(data.property_was_vacant)
        set_testing_device_placed(data.testing_device_placed)
        set_testing_device_reason(data.testing_device_reason)
        set_observed_closed_building(data.observed_closed_building)
        set_building_temperature(data.building_temperature)
        set_radon_test_device_moved(data.radon_test_device_moved)
        set_test_data_interference(data.test_data_interference)
        set_tamper_resistant_device(data.tamper_resistant_device)
        set_radon_mitigation_observed(data.radon_mitigation_observed)
        set_test_system_operational(data.test_system_operational)
        set_temporary_mitigation_observed(data.temporary_mitigation_observed)
        set_temporary_mitigation_observed_description(data.temporary_mitigation_observed_description)
        set_heat_recovery_ventilator(data.heat_recovery_ventilator)
        set_operation_during_test(data.operation_during_test)
        set_functional_properly_maintained(data.functional_properly_maintained)
        set_intake_free_of_obstacles(data.intake_free_of_obstacles)
        set_severe_storms(data.severe_storms)
        set_passive_crawlspace(data.passive_crawlspace)
        set_passive_crawlspace_open_closed(data.passive_crawlspace_open_closed)
        set_active_or_passive_air(data.active_or_passive_air)
        set_operating_as_intended(data.operating_as_intended)
        set_forced_air(data.forced_air)
        set_fan_setting(data.fan_setting)
        set_sub_slab_ducts(data.sub_slab_ducts)
        set_air_handler_fan(data.air_handler_fan)
        set_unavoidable_construction(data.unavoidable_construction)
        set_other_temporary_factors(data.other_temporary_factors)
    }



    useEffect(() => {
        loadRadonTest();
    }, [])

    const UpdateRadonTestReport = async () => {
        setDoneSubmitting(true)
        let formField = new FormData()
        formField.append('client_name', client_name)
        formField.append('test_address', test_address)
        formField.append('city', city)
        formField.append('state', state)
        formField.append('zip', zip)
        formField.append('manufacturer_and_model1', manufacturer_and_model1)
        formField.append('serial_number1', serial_number1)
        formField.append('calibration_date1', calibration_date1)
        formField.append('test_location1', test_location1)
        formField.append('start_date1', start_date1)
        formField.append('start_time1', start_time1)
        formField.append('end_date1', end_date1)
        formField.append('end_time1', end_time1)
        formField.append('average_radon_level1', average_radon_level1)
        formField.append('manufacturer_and_model2', manufacturer_and_model2)
        formField.append('serial_number2', serial_number2)
        formField.append('calibration_date2', calibration_date2)
        formField.append('test_location2', test_location2)
        formField.append('start_date2', start_date2)
        formField.append('start_time2', start_time2)
        formField.append('end_date2', end_date2)
        formField.append('end_time2', end_time2)
        formField.append('average_radon_level2', average_radon_level2)
        formField.append('pcil2', pcil2)
        formField.append('licensed_radon_professional', licensed_radon_professional)
        formField.append('MDH_license_number', MDH_license_number)
        formField.append('email', email)
        formField.append('phone', phone)
        formField.append('fax', fax)
        formField.append('operating_as_intended', operating_as_intended)
        formField.append('passive_crawlspace_open_closed', passive_crawlspace_open_closed)
        formField.append('noninterference_agreement', noninterference_agreement)
        formField.append('test_conditions_observed', test_conditions_observed)
        formField.append('property_was_vacant', property_was_vacant)
        formField.append('testing_device_placed', testing_device_placed)
        formField.append('testing_device_reason', testing_device_reason)
        formField.append('observed_closed_building', observed_closed_building)
        formField.append('building_temperature', building_temperature)
        formField.append('radon_test_device_moved', radon_test_device_moved)
        formField.append('test_data_interference', test_data_interference)
        formField.append('tamper_resistant_device', tamper_resistant_device)
        formField.append('radon_mitigation_observed', radon_mitigation_observed)
        formField.append('test_system_operational', test_system_operational)
        formField.append('temporary_mitigation_observed', temporary_mitigation_observed)
        formField.append('temporary_mitigation_observed_description', temporary_mitigation_observed_description)
        formField.append('heat_recovery_ventilator', heat_recovery_ventilator)
        formField.append('operation_during_test', operation_during_test)
        formField.append('functional_properly_maintained', functional_properly_maintained)
        formField.append('intake_free_of_obstacles', intake_free_of_obstacles)
        formField.append('severe_storms', severe_storms)
        formField.append('passive_crawlspace', passive_crawlspace)
        formField.append('active_or_passive_air', active_or_passive_air)
        formField.append('forced_air', forced_air)
        formField.append('fan_setting', fan_setting)
        formField.append('sub_slab_ducts', sub_slab_ducts)
        formField.append('air_handler_fan', air_handler_fan)
        formField.append('unavoidable_construction', unavoidable_construction)
        formField.append('other_temporary_factors', other_temporary_factors)

        await axios({
            method: 'PUT',
            url: `https://homesafetysolutions.pythonanywhere.com/api/radon_test_report/update/${useId}/`,
            // url: `http://127.0.0.1:8000/api/radon_test_report/update/${useId}/`,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            data: formField,
        }).then(() => {
            navigate('/operations_forms/')
        })
        setDoneSubmitting(false)
    }

    return (
        <div className={'formcontainer'}>
            {/*<h1>Create Client {work_site_address}</h1>*/}
            <br/>


                    <Form style={{padding: '0'}}>
                        <br/>
                        <div style={{textAlign: "center"}}>


                            <img
                                src={'letterHeadLogo.png'}
                                alt={'Letter Head Logo'}/>

                            <strong>
                                <p style={{margin: '0'}}>
                                    Anything Less is Unforgivable!
                                </p>
                                <p style={{margin: '0'}}>
                                    Ph: 612-490-1295 Office: 763-434-3263
                                </p>
                                <p style={{margin: '0'}}>
                                    3140 Viking Blvd NE, East Bethel, MN 55092 www.homesafetysolutionsinc.com
                                </p>
                                <p style={{margin: '0'}}>
                                    walt@homesafetysolutionsinc.com
                                </p>
                            </strong>
                        </div>
                        <br/>
                        <hr style={{color: 'orange', height: '3px'}}/>
                        <br/>
                        <div style={{textAlign: 'center'}}>
                            <p>Radon Test Report</p>
                        </div>

                        <Row>
                            <Col>
                                    <span style={{fontWeight: 'bold'}}>
                                        Company Name: Home Safety Solutions <br />
                                    </span>
                                <u style={{fontWeight: 'bold'}}>
                                    Client Information
                                </u>
                                <br/>

                                Name:
                                <Form.Group controlId={'client_name'}>
                                    <Form.Control
                                        // aria-required={true}
                                        type={'text'}
                                        placeholder={"client name"}
                                        name={'client_name'}
                                        value={client_name}
                                        onChange={(e) => set_client_name(e.target.value)}
                                    />
                                </Form.Group>
                                <br/>


                                Test Address:
                                <Form.Group controlId={'test_address'}>
                                    <Form.Control
                                        // aria-required={true}
                                        type={'text'}
                                        placeholder={"test address"}
                                        name={'test_address'}
                                        value={test_address}
                                        onChange={(e) => set_test_address(e.target.value)}
                                    />
                                </Form.Group>
                                <br/>
                                <Row>
                                    <Col>
                                        City:
                                        <Form.Group controlId={'city'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"city"}
                                                name={'city'}
                                                value={city}
                                                onChange={(e) => set_city(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        State:
                                        <Form.Group controlId={'state'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"state"}
                                                name={'state'}
                                                value={state}
                                                onChange={(e) => set_state(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Zip:
                                        <Form.Group controlId={'zip'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"zip"}
                                                name={'zip'}
                                                value={zip}
                                                onChange={(e) => set_zip(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <br />
                        <br />

                        <div className={'section1RadonTest'}>
                            <u style={{fontWeight: 'bold'}}>Device Information</u> <br/>
                            Test Unit #1<br/>
                            <div style={{paddingLeft: '25px'}}>
                                <br/>
                                <Row>
                                    <Col>
                                        Manufacturer & Model:
                                        <Form.Group controlId={'manufacturer_and_model1'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"manufacturer and model"}
                                                name={'manufacturer_and_model1'}
                                                value={manufacturer_and_model1}
                                                onChange={(e) => set_manufacturer_and_model1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Serial #:
                                        <Form.Group controlId={'serial_number1'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"serial number 1"}
                                                name={'serial_number1'}
                                                value={serial_number1}
                                                onChange={(e) => set_serial_number1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Calibration Date:
                                        <Form.Group controlId={'calibration_date1'}>
                                            <Form.Control
                                                type={'date'}
                                                value={calibration_date1}
                                                onChange={(e) => set_calibration_date1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    Test Location:
                                    <Form.Group controlId={'test_location1'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"test location 1"}
                                            name={'test_location1'}
                                            value={test_location1}
                                            onChange={(e) => set_test_location1(e.target.value)}
                                        />
                                    </Form.Group>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        Start Date:
                                        <Form.Group controlId={'start_date1'}>
                                            <Form.Control
                                                type={'date'}
                                                value={start_date1}
                                                onChange={(e) => set_start_date1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Start Time:
                                        <Form.Group controlId={'start_time1'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"start time 1"}
                                                name={'start_time1'}
                                                value={start_time1}
                                                onChange={(e) => set_start_time1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        End Date:
                                        <Form.Group controlId={'end_date1'}>
                                            <Form.Control
                                                type={'date'}
                                                value={end_date1}
                                                onChange={(e) => set_end_date1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        End Time:
                                        <Form.Group controlId={'end_time1'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"end_time1"}
                                                name={'end_time1'}
                                                value={end_time1}
                                                onChange={(e) => set_end_time1(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Average Radon Level:
                                        <Form.Group controlId={'average_radon_level1'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"average radon level 1"}
                                                name={'average_radon_level1'}
                                                value={average_radon_level1}
                                                onChange={(e) => set_average_radon_level1(e.target.value)}
                                            />
                                        </Form.Group>
                                        pCi/L
                                    </Col>
                                </Row>
                            </div>

                            Test Unit #2<br/>
                            <div style={{paddingLeft: '25px'}}>
                                <br/>
                                <Row>
                                    <Col>
                                        Manufacturer & Model:
                                        <Form.Group controlId={'manufacturer_and_model2'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"manufacturer and model 2"}
                                                name={'manufacturer_and_model2'}
                                                value={manufacturer_and_model2}
                                                onChange={(e) => set_manufacturer_and_model2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Serial #:
                                        <Form.Group controlId={'serial_number2'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"serial number 2"}
                                                name={'serial_number2'}
                                                value={serial_number2}
                                                onChange={(e) => set_serial_number2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Calibration Date:
                                        <Form.Group controlId={'calibration_date2'}>
                                            <Form.Control
                                                type={'date'}
                                                value={calibration_date2}
                                                onChange={(e) => set_calibration_date2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    Test Location:
                                    <Form.Group controlId={'test_location2'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"test location 2"}
                                            name={'test_location2'}
                                            value={test_location2}
                                            onChange={(e) => set_test_location2(e.target.value)}
                                        />
                                    </Form.Group>
                                </Row>
                                <br />
                                <Row>
                                    <Col>
                                        Start Date:
                                        <Form.Group controlId={'start_date2'}>
                                            <Form.Control
                                                type={'date'}
                                                value={start_date2}
                                                onChange={(e) => set_start_date2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Start Time:
                                        <Form.Group controlId={'start_time2'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"start time 2"}
                                                name={'start_time2'}
                                                value={start_time2}
                                                onChange={(e) => set_start_time2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        End Date:
                                        <Form.Group controlId={'end_date2'}>
                                            <Form.Control
                                                type={'date'}
                                                value={end_date2}
                                                onChange={(e) => set_end_date2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        End Time:
                                        <Form.Group controlId={'end_time2'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"end time 2"}
                                                name={'end_time2'}
                                                value={end_time2}
                                                onChange={(e) => set_end_time2(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        Average Radon Level:
                                        <Form.Group controlId={'average_radon_level2'}>
                                            <Form.Control
                                                // aria-required={true}
                                                type={'text'}
                                                placeholder={"average radon level 2"}
                                                name={'average_radon_level2'}
                                                value={average_radon_level2}
                                                onChange={(e) => set_average_radon_level2(e.target.value)}
                                            />
                                        </Form.Group>
                                        pCi/L
                                    </Col>
                                </Row>
                            </div>
                            <br />
                            <ul>
                                <li>
                                    If test #2 was for QA, the average radon results is
                                    <Form.Group controlId={'pcil2'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"pcil2"}
                                            name={'pcil2'}
                                            value={pcil2}
                                            onChange={(e) => set_pcil2(e.target.value)}
                                        />
                                    </Form.Group>
                                    pCi/L. This value should be used for mitigation decisions.
                                </li>
                                <li>
                                    If multiple foundation types were tested, consider the results separately for mitigation decision.
                                </li>
                            </ul>
                        </div>

                        <div className={'section2RadonTest'}>
                            <u style={{fontWeight: 'bold'}}>
                                Radon Test Data
                            </u>
                            <p>
                                Attached to this report is a copy of the actual test data taken from a Minnesota
                                Department of Health-approved testing device. The test was performed in accordance
                                with the current ANSI/AARST standards and guidelines accepted for radon testing.
                            </p>
                            <Row>
                                <Col>
                                    Licensed Radon Professional:
                                    <Form.Group controlId={'licensed_radon_professional'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"licensed radon professional"}
                                            name={'licensed_radon_professional'}
                                            value={licensed_radon_professional}
                                            onChange={(e) => set_licensed_radon_professional(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    MDH Licence Number:
                                    <Form.Group controlId={'MDH_license_number'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"MDH license number"}
                                            name={'MDH_license_number'}
                                            value={MDH_license_number}
                                            onChange={(e) => set_MDH_license_number(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    Email:
                                    <Form.Group controlId={'email'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"email"}
                                            name={'email'}
                                            value={email}
                                            onChange={(e) => set_email(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    Phone:
                                    <Form.Group controlId={'phone'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"phone"}
                                            name={'phone'}
                                            value={phone}
                                            onChange={(e) => set_phone(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    Fax:
                                    <Form.Group controlId={'fax'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"fax"}
                                            name={'fax'}
                                            value={fax}
                                            onChange={(e) => set_fax(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                        </div>

                        <br />

                        <div className={'section3RadonTest'}>
                            <u style={{fontWeight: 'bold'}}>
                                Recommendations
                                <br />
                            </u>
                            Test Result is 4.0 pCi/L or greater:
                            <ul>
                                <li>
                                    Fix the building if test results indicate occupants may be exposed to radon concentrations that meet or exceed the EPA action level of 4.0 pCi/l
                                </li>
                                <li>
                                    Efforts to reduce radon concentrations are not complete until a retest provides evidence of effectiveness.
                                </li>
                                <ul>
                                    <li>
                                        Complete a short-term radon test between 24 hours and 30 days after the installation of a mitigation system.
                                    </li>
                                    <li>
                                        Retest every 2 years to ensure the system remains effective.
                                    </li>
                                </ul>
                            </ul>
                            <br />
                            Test results between 2.0 and 4.0 pCi/L
                            <br />
                            <ul>
                                <li>
                                    Consider fixing the building if the test results indicate radon levels greater than half the action level.
                                </li>
                                <li>
                                    Tests conducted when heating systems are active both day and night are more likely
                                    to provide a clear characterization of potential radon hazards.
                                </li>
                            </ul>
                        </div>

                        <br />

                        <div className={'section4RadonTest'}>
                            <u style={{fontWeight: 'bold'}}>
                                When to Retest
                            </u>
                            <br />
                            <ul>
                                <li>
                                    Retest every 5 years if NO mitigation system is installed.
                                </li>
                                <li>
                                    Retest in conjunction with the sale of any new or existing buildings.
                                </li>
                                <li>
                                    Be certain to test again if and when any of the following circumstances occur:
                                    <ul>
                                        <li>
                                            A new addition is constructed or alterations for building rehab or re-configuration occur;
                                        </li>
                                        <li>
                                            A ground contact area not previously tested is occupied, or a home is newly occupied.
                                        </li>
                                        <li>
                                            Heating and cooling systems are significantly altered.
                                        </li>
                                        <li>
                                            Ventilation is significantly altered by extensive weatherization, changes to mechanical systems, or comparable procedures;
                                        </li>
                                        <li>
                                            Significant openings to the soil occur due to:
                                            <ul>
                                                <li>
                                                    Groundwater or slab surface water control systems that are altered or added (ex. sumps, perimeter drain tile, shower/tub retrofits) or,
                                                </li>
                                                <li>
                                                    Natural settlement causing major cracks to develop
                                                </li>
                                                <li>
                                                    Earthquakes, construction blasting, or formation of sinkholes nearby; or A
                                                </li>
                                                <li>
                                                    mitigation system is altered, modified, or repaired.
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <br />

                        <div className={'section5RadonTest'}>
                            <u style={{fontWeight: 'bold'}}>
                                Radon Information
                            </u>
                            <br />
                            <p>
                                More information about radon is available by contacting the Minnesota Department of
                                Health at: Phone: 651-201-4601 Website: mn.gov/radon Email: health.indoorair@state.mn.us
                            </p>
                        </div>

                        <br />

                        <div className={'section6RadonTest'}>
                            <u style={{fontWeight: 'bold'}}>
                                Conditions Observed During The Test
                            </u>
                            <p>
                                The noninterference agreement was:
                                <Form.Group controlId={'noninterference_agreement'}>
                                    <Form.Select
                                        // value={service_order}
                                        onChange={(e) => set_noninterference_agreement(e.target.value)}
                                        defaultValue={'DEFAULT'}
                                    >
                                        <option value="DEFAULT" disabled>Agreement Was?</option>
                                        <option value="Signed">Signed</option>
                                        <option value="Not Signed">Not Signed</option>
                                    </Form.Select>
                                </Form.Group>
                            </p>
                            <p>
                                The required test conditions were observed at deployment and retrieval:
                                <Form.Group controlId={'test_conditions_observed'}>
                                    <Form.Select
                                        // value={service_order}
                                        onChange={(e) => set_test_conditions_observed(e.target.value)}
                                        defaultValue={'DEFAULT'}
                                    >
                                        <option value="DEFAULT" disabled>Conditions were observed?</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </Form.Select>
                                </Form.Group>
                            </p>
                            <p>
                                Radon levels in a home can be influenced by many factors including weather, season,
                                living conditions, and occupancy patterns. Temperary conditions observed during the
                                testing period may cause the test to not reflect the client's risk from radon. The
                                radon levels stated for this time period had the following situations present:
                            </p>
                            <div style={{paddingLeft: '35px'}}>
                                <p>
                                    <Form.Group controlId={'property_was_vacant'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_property_was_vacant(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Vacant?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Property was vacant during testing.
                                </p>
                                <p>
                                    <Form.Group controlId={'testing_device_placed'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_testing_device_placed(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Location didn't meet min requirements?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Testing device(s) was placed in a location that doesn't meet minimum requirements of this standard. This was unavoidable because:
                                    <Form.Group controlId={'testing_device_reason'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"testing_device_reason"}
                                            name={'testing_device_reason'}
                                            value={testing_device_reason}
                                            onChange={(e) => set_testing_device_reason(e.target.value)}
                                        />
                                    </Form.Group>
                                </p>
                                <p>
                                    <Form.Group controlId={'observed_closed_building'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_observed_closed_building(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Observed Closed Building?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Observed closed building conditions were not maintained 12 hours prior to/during the test.
                                </p>
                                <p>
                                    <Form.Group controlId={'building_temperature'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_building_temperature(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Building temperature normal</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Building temperature was outside of normal occupied range of 65-80 degrees
                                </p>
                                <p>
                                    <Form.Group controlId={'radon_test_device_moved'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_radon_test_device_moved(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>radon test device moved?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Radon testing device was moved during the test.
                                </p>
                                <p>
                                    <Form.Group controlId={'test_data_interference'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_test_data_interference(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Deviation from protocol?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    In the measurement professional's opinion, test data produced by the CRM may indicate interference or deviation from testing protocols.
                                </p>
                                <p>
                                    <Form.Group controlId={'tamper_resistant_device'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_tamper_resistant_device(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Interference with testing conditions?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Tamper-resistant features of the device or other methods, indicate possible interference with testing conditions.
                                </p>
                                <p>
                                    <Form.Group controlId={'radon_mitigation_observed'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_radon_mitigation_observed(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Radon Mit system observed?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    A radon mitigation system was observed. The system was operational:
                                    <Form.Group controlId={'test_system_operational'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_test_system_operational(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>test system operational?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                            <option value="Unknown">Unknown</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    <Form.Group controlId={'temporary_mitigation_observed'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_temporary_mitigation_observed(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Temporary mit observed?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                            <option value="Unknown">Unknown</option>
                                        </Form.Select>
                                    </Form.Group>
                                    A temporary mitigation strategy was observed. <br/>
                                    Describe:
                                    <Form.Group controlId={'temporary_mitigation_observed_description'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"temporary mitigation observed description"}
                                            name={'temporary_mitigation_observed_description'}
                                            value={temporary_mitigation_observed_description}
                                            onChange={(e) => set_temporary_mitigation_observed_description(e.target.value)}
                                        />
                                    </Form.Group>
                                </p>
                                <p>
                                    <Form.Group controlId={'heat_recovery_ventilator'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_heat_recovery_ventilator(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Heat exchanger?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    A heat recovery ventilator or air-to-air heat exchanger, is installed in the building.<br/>
                                    Operating during the test?<br/>
                                    <Form.Group controlId={'operation_during_test'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_operation_during_test(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Operation during test?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                            <option value="Unknown">Unknown</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Functional and properly maintained?<br/>
                                    <Form.Group controlId={'functional_properly_maintained'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_functional_properly_maintained(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Functional properly maintained?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                            <option value="Unknown">Unknown</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Intake free of obstacles/debris?<br/>
                                    <Form.Group controlId={'intake_free_of_obstacles'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_intake_free_of_obstacles(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Intake free of obstacles?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                            <option value="Unknown">Unknown</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    <Form.Group controlId={'severe_storms'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_severe_storms(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Severe storms?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Unusually severe storms or periods of unusually high winds occurred during the test.
                                </p>
                                <p>
                                    <Form.Group controlId={'passive_crawlspace'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_passive_crawlspace(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Passive Crawlspace?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Passive crawlspace vents to the outside
                                    <Form.Group controlId={'passive_crawlspace_open_closed'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_passive_crawlspace_open_closed(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Open/Closed?</option>
                                            <option value="Open">Open</option>
                                            <option value="Closed">Closed</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    <Form.Group controlId={'active_or_passive_air'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_active_or_passive_air(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>active or passive air?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                    Active or passive air supplies to the building or to combustion appliances were:
                                    <Form.Group controlId={'operating_as_intended'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_operating_as_intended(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Operating as intended?</option>
                                            <option value="Operating_as_intended">Operating as intended</option>
                                            <option value="Blocked">Blocked</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    Forced-air HVAC System?
                                    <Form.Group controlId={'forced_air'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_forced_air(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Forced-air HVAC?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    Fan Setting:
                                    <Form.Group controlId={'fan_setting'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_fan_setting(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Fan setting?</option>
                                            <option value="On">On</option>
                                            <option value="Auto">Auto</option>
                                            <option value="Off">Off</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    Sub-slab return ducts
                                    <Form.Group controlId={'sub_slab_ducts'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_sub_slab_ducts(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Sub slab ducts?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    Air handler fan activity was minimal during test period
                                    <Form.Group controlId={'air_handler_fan'}>
                                        <Form.Select
                                            // value={service_order}
                                            onChange={(e) => set_air_handler_fan(e.target.value)}
                                            defaultValue={'DEFAULT'}
                                        >
                                            <option value="DEFAULT" disabled>Air handler activity?</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                </p>
                                <p>
                                    Unavoidable construction activities were being done to the house that could possibly have affected radon levels. <br />
                                    Describe:
                                    <Form.Group controlId={'unavoidable_construction'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"unavoidable construction"}
                                            name={'unavoidable_construction'}
                                            value={unavoidable_construction}
                                            onChange={(e) => set_unavoidable_construction(e.target.value)}
                                        />
                                    </Form.Group>
                                    <br />
                                    Other temporary factors that could have influenced the test results, including:
                                    <Form.Group controlId={'other_temporary_factors'}>
                                        <Form.Control
                                            // aria-required={true}
                                            type={'text'}
                                            placeholder={"other temporary factors"}
                                            name={'other_temporary_factors'}
                                            value={other_temporary_factors}
                                            onChange={(e) => set_other_temporary_factors(e.target.value)}
                                        />
                                    </Form.Group>
                                    <br />
                                </p>
                            </div>
                        </div>

                        <br/>
                    </Form>

                    {
                        doneSubmitting
                            ?
                            (
                                <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                            )
                            :
                            (
                                <Button className={'btn btn-success'} onClick={UpdateRadonTestReport}>
                                    Add Radon Test Report
                                </Button>
                            )
                    }


        </div>
    )
}

export default UpdateRadonTestReport
